import type { FaireProductEntity } from "../../entity_types/product";

export const p_4a4zr42428: FaireProductEntity = {
  token: "p_4a4zr42428",
  type: "product",
  name: "Stress Relief Cube Sensory Fidget Toy",
  brandToken: "b_9drv3ax8mr",
  brandName: "Plush Looks",
  imageUrl:
    "https://cdn.faire.com/fastly/aac4d80e0dbf3c551d26ffeb1207cea2c7cb701f032f5f0340b77e26cd51321d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0cbb7edebd82bb096d63d952fd44366ed79b09e8b584e7bb39d3a869534eb20.jpeg",
    "https://cdn.faire.com/fastly/7d80676eaf45f2efb8ce88340261f7dfc1f97efefeee763507551162556e2a48.jpeg",
    "https://cdn.faire.com/fastly/48e8d33c3b755cbaa944eb97308582077570c0be099b89bccd1b699c66a81a4e.jpeg",
    "https://cdn.faire.com/fastly/bb5ce688c98c361ae4e43f08e970239443851348d4ce65166034548b9a6db011.jpeg",
    "https://cdn.faire.com/fastly/28e08d6dbd4334a67515c46ae1d5aae6c619b1c73545b9dba2346a6fdb3bd7c2.jpeg",
    "https://cdn.faire.com/fastly/3624b87a4b17c9ca91da0276948630d688398650c69e8f03bc159583b0951e22.jpeg",
    "https://cdn.faire.com/fastly/4038cf1eb4829b66a4d9b47aad0dc08115965c07a8a351068d8bbdb4d6b0f769.jpeg",
    "https://cdn.faire.com/fastly/0afea5fc26c7f5e95adc22ee4dafed64d141091e40dd5eb247fe9e3167098781.jpeg",
    "https://cdn.faire.com/fastly/1d483099321cff9668f730115e8a6ecff76e75431eaa7171d99cbf74dfb869b4.jpeg",
    "https://cdn.faire.com/fastly/ee3dfb730102d182f7ec24863968064181765e3e6ff0baad8996739fd54ad893.jpeg",
    "https://cdn.faire.com/fastly/8dc28d29028165f5d338a06adcec3a498228d156509fc51d0c2c0d453d58680b.jpeg",
    "https://cdn.faire.com/fastly/f628128654303deaca99a6409645b85067d10c680b17b8d016245ebf249c56e7.jpeg",
    "https://cdn.faire.com/fastly/66d39dd5432d156173720fb24497fc6589d72e98c67dc308fc7e8679cea96bc5.jpeg",
    "https://cdn.faire.com/fastly/2f4d5941a1dde40b91e48ff8f2917d5bf0e69795013aab7f50a9c1df1618a450.jpeg",
    "https://cdn.faire.com/fastly/48b8f0fb92da9fe4c65b53d6fc36b2cb055b6f4060aeb4ef50b3ef7475335a1d.jpeg",
    "https://cdn.faire.com/fastly/f1178905fd16ae57d0e1d0a26e87263302e20f714730168ea22ee68570ae4147.jpeg",
    "https://cdn.faire.com/fastly/8ab8584b181c5030dacb9c82a9b765c240dafd24bfe338f339123d82bc4cdc27.jpeg",
    "https://cdn.faire.com/fastly/c74c55aeeddb2fcd4ad1b926ee45854cbd957a5feba0c71fa24b0094eb915322.jpeg",
    "https://cdn.faire.com/fastly/a27f6bd456996b6a1e8738ac581315a2b3e74e3a633f295b2047a4f8ad8e99c6.jpeg",
    "https://cdn.faire.com/fastly/b9f67eb8f72585a5cc8e922f3584a69c87c05b9a577afd0ff62339c69b6580c5.jpeg",
    "https://cdn.faire.com/fastly/82146ddd7f072457e4bae752bb4a65436c99f5fe8476e2c2191f1b3d6d21f2cd.jpeg",
    "https://cdn.faire.com/fastly/91cc46c3512bac5da1aeb1ff4a133ca125b4ea95747eb0bcb7f99a5ab10f7b9c.jpeg",
  ],
  priceDollars: 4.49,
  description:
    "Experience sensory play with Plush Looks' Stress Relief Cube. This fidget toy is designed for kids, offering a tactile experience that's calming and engaging. It's ideal for moments of quiet focus, helping to soothe anxious energy and improve concentration. Compact and lightweight, it's a great choice for stress relief on the go. All prices include tax, with no additional charges.",
  tags: [],
  msrpDollars: 8.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:27.256Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
